import { useState } from "react";
import CheckinReport from "./reports/CheckinReport";
import FirstVisitsReport from "./reports/FirstVisitsReport";
import PayrollReport from "./reports/PayrollReport";
import MonthlyRevenueReport from "./reports/MonthlyRevenueReport";
import WorkshopRevenueReport from "./reports/WorkshopRevenueReport";
import MerchReport from "./reports/MerchReport";
import WaiverReport from "./reports/WaiverReport";
import { LegacyAttendanceReport, LegacyRevenueReport } from "./reports/LegacyReports";
import "../admin-base.css";
import "../admin-layout.css";
import "../admin-controls.css";
import "../admin-responsive.css";
import "./reportsTab.css";

const REPORT_OPTIONS = [
  { id: "checkin",          label: "R1 — Check-in" },
  { id: "first-visits",     label: "R2 — First Visits" },
  { id: "payroll",          label: "R4 — Payroll" },
  { id: "monthly-revenue",  label: "R5 — Monthly Revenue" },
  { id: "workshop-revenue", label: "R6 — Workshop Revenue" },
  { id: "merch",            label: "R7 — Merch Sales" },
  { id: "waivers",          label: "R8 — Waivers" },
  { id: "attendance",       label: "Attendance (legacy)" },
  { id: "revenue",          label: "Revenue (legacy)" },
  { id: "pass-alerts",      label: "Pass Alerts" },
];

export default function ReportsTab() {
  const [activeReport, setActiveReport] = useState("checkin");

  const reportComponent = () => {
    switch (activeReport) {
      case "checkin":          return <CheckinReport />;
      case "first-visits":     return <FirstVisitsReport />;
      case "payroll":          return <PayrollReport />;
      case "monthly-revenue":  return <MonthlyRevenueReport />;
      case "workshop-revenue": return <WorkshopRevenueReport />;
      case "merch":            return <MerchReport />;
      case "waivers":          return <WaiverReport />;
      case "attendance":       return <LegacyAttendanceReport />;
      case "revenue":
      case "pass-alerts":      return <LegacyRevenueReport />;
      default:                 return null;
    }
  };

  return (
    <div className="adm-tab-content adm-reports">
      <div className="adm-report-selector">
        <label className="adm-filter-label">Report</label>
        <select className="adm-input adm-report-dropdown" value={activeReport} onChange={e => setActiveReport(e.target.value)}>
          <optgroup label="Reports">
            {REPORT_OPTIONS.slice(0, 7).map(r => <option key={r.id} value={r.id}>{r.label}</option>)}
          </optgroup>
          <optgroup label="Legacy">
            {REPORT_OPTIONS.slice(7).map(r => <option key={r.id} value={r.id}>{r.label}</option>)}
          </optgroup>
        </select>
      </div>
      <div className="adm-report-body">
        {reportComponent()}
      </div>
    </div>
  );
}